import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Breadcrumb } from 'react-bootstrap';

// Actions
import { formatAvailableInstances } from './../../../../../actions/closeLoop/apmDashboard/instancesActions';

// Components
import Loader from './../../../../../utilityComponents/Loader';
import Flash from './../../../../../utilityComponents/Message';
import InstanceInfo from './InstanceInfo';
import PropTypes from "prop-types";


function InstancesStats(props) {
    const [ regionName, setRegionName ] = useState(undefined);

    useEffect(() => {
        const { region } = props.match.params;
        props.fetchInstances(region);
        setRegionName(region);
    }, [])

    return(
        <>
            <Breadcrumb>
                <Breadcrumb.Item href='/navigate_new'>Home</Breadcrumb.Item>
                <Breadcrumb.Item href='/close_loop/real_time/apm/dashboard'>Regions</Breadcrumb.Item>
                <Breadcrumb.Item active>Running Instances</Breadcrumb.Item>
            </Breadcrumb>
            <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingTop: '1%' }}>
                <div style={{ width: 'auto', minWidth: '100%' }}>
                    { props.loading ? <Loader /> : props.error ?
                     (<Flash variant={'danger'}>{ props.error }</Flash>) : props.availableInstances.length === 0 ?
                     (<Flash variant='info'>No instances are running currently in this region!</Flash>) :
                     props.availableInstances && props.availableInstances.map((item) => (
                            <Row key={item.id} >
                                {item.values.map((subItem) => (
                                    <Col xs lg={2} key={subItem['instance_id']}>
                                        <InstanceInfo
                                            {...props}
                                            region={regionName}
                                            instance={subItem['instance_id']}
                                        />
                                    </Col>
                                ))}
                            </Row>
                     ))}
                 </div>
             </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    loading: state.availableInstances.loading,
    error: state.availableInstances.error,
    availableInstances: state.availableInstances.availableInstances
});

const mapDispatchToProps = (dispatch) => ({
    fetchInstances: (payload) => dispatch(formatAvailableInstances(payload))
});

InstancesStats.propTypes = {
    match: PropTypes.array,
    fetchInstances: PropTypes.func,
    loading: PropTypes.bool,
    error: PropTypes.string,
    availableInstances: PropTypes.array,
};
InstancesStats.defaultProps = {
    match: [],
    loading: false,
    error: '',
    availableInstances: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(InstancesStats);